import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LayoutGeneral from "../LayoutGeneral";
import { RUTAS_USER } from "../Rutas";
import cargando from '../Imagenes/Cargando.gif'
import "./Actualizar_Usuario.css";

const ActualizarUsuario = () => {
  const navigate = useNavigate();
  // Campo proveniente de la URL
  const { idUsuario } = useParams();
  // Campos principales
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [esAdmin, setEsAdmin] = useState(0);
  const [estatusUsuario, setEstatusUsuario] = useState("");
  // Campo de busqueda
  const [codEmp, setCodEmp] = useState("");
  const [empleados, setEmpleados] = useState([]);
  // Campos secundarios de busqueda
  const [rol, setRol] = useState(""); 
  const [roles, setRoles] = useState([]);
  // Catálogo de usuarios
  const [usuarios, setUsuarios] = useState([]);
  // Mensajes
  const [mensaje, setMensaje] = useState("");
  const [mensajeTipo, setMensajeTipo] = useState(""); // success / error
  const [cargandoSucess, setCargandoSucess] = useState(false);
  // Redireccionamientos
  const regresarUsuarios = () => { navigate("/Usuarios"); };

  // Obtener datos de entrada
  useEffect(() => {
    // Traer Roles
    const fetchRoles = async () => {
      try {
        const res = await fetch(RUTAS_USER.GET_ROLES);
        const data = await res.json();
        setRoles(data);
      } catch (error) {
        console.error("Error cargando roles:", error);
      }
    };
    fetchRoles();

    // Traer Usuarios
    const fetchUsuarios = async () => {
      try {
        const res2 = await fetch(RUTAS_USER.GET_USERS);
        const data2 = await res2.json();
        setUsuarios(data2);
      } catch (error2) {
        console.error("Error cargando usuarios:", error2);
      }
    };
    fetchUsuarios();
  }, []);

  useEffect(() => {
    // Solo cargar usuario si ya tenemos roles
    if (!idUsuario || roles.length === 0) return;
    const fetchUsuarioById = async () => {
      try {
        const res = await fetch(RUTAS_USER.GET_USERBYID(idUsuario));
        if (!res.ok) throw new Error("No se pudo obtener el usuario");
        const data = await res.json();
        setNombre(data.nombre || "");
        setEmail(data.email || "");
        setEstatusUsuario(data.estatusUsuario ?? 1);
        setEsAdmin(data.admin || 0);
        if (Array.isArray(data.oficinas)) {
          setEmpleados(
            data.oficinas.map(of => ({
              codigo: of.clave,
              Nombre: of.nombreIntermediario || "",
              Oficina: of.oficina,
              estatusOficina: of.estatusOficina || 0,
              Rol: roles.find(r => r.idRol === of.idRol)?.rol || "",
              jefe: of.jefe,
            }))
          );
        }
      } catch (error) {
        setMensaje("❌ Error al cargar datos del usuario.");
        setMensajeTipo("error");
      }
    };
    fetchUsuarioById();
  }, [idUsuario, roles]);
  
  // Validar código empleado
  const validarCodEmp = async () => {
    if (!codEmp.trim() || !rol.trim()) {
      setMensaje("⚠️ Ingresa un código y selecciona un rol.");
      setMensajeTipo("error");
      return;
    }

    try {
      const res = await fetch(RUTAS_USER.VALID_USER, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          idRol: rol.trim(), // viene del select
          codigo: codEmp.trim(), // viene del input
        }),
      });

      if (!res.ok) throw new Error("Error validando código");
      const data = await res.json();

      if (data && data.codigo) {
        // Evitar duplicados
        if (empleados.some((e) => e.codigo === data.codigo)) {
          setMensaje("⚠️ El código ya fue agregado.");
          setMensajeTipo("error");
        } else { 
          // Normalizar el objeto para que case con tu tabla
          const nuevoEmpleado = {
            codigo: data.codigo,
            Nombre: data.nombre,
            Oficina: data.oficina,
            Rol: roles.find((r) => r.idRol === data.idRol)?.rol || "N/A",
          };

          setEmpleados([...empleados, nuevoEmpleado]);
          setMensaje("✅ Código agregado correctamente.");
          setMensajeTipo("success");
        }
      } else {
        setMensaje("❌ Código  --> " + data.codigo + " <----- no encontrado.");
        setMensajeTipo("error");
      }
    } catch (error) {
      console.error("Error:", error);
      setMensaje("❌ Error al validar el código.");
      setMensajeTipo("error");
    }    
    setCodEmp("");
    setRol("");
  };

  // Guardar usuario
  const guardarUsuario = async (e) => {
    e.preventDefault();

    if (!nombre || !email) {
      setMensaje("⚠️ Por favor completa todos los campos.");
      setMensajeTipo("error");
      return;
    }
    if (empleados.length === 0) {
      setMensaje("⚠️ Debes asignar al menos un código de empleado.");
      setMensajeTipo("error");
      return;
    }

    const ActualizarUsuario = {
      email: email,   
      pass: "cualquiera", // No se actualiza la contraseña    
      nombre: nombre,     
      creador: "1",
      estatus: estatusUsuario, // 1 o 0
      idUsuario: parseInt(idUsuario, 10), // usuario a actualizar
      admin: esAdmin,
      oficinas: empleados.map(emp => ({
        clave: emp.codigo,
        idUsuario: emp.jefe || 0, 
        idRol: roles.find(r => r.rol === emp.Rol)?.idRol || 0,
        oficina: emp.Oficina,
        estatusOficina: Number(emp.estatusOficina),
        nombreIntermediario: emp.Nombre || "",
        jefe: emp.jefe || 0,
        creador: 1,
        nombreOficina: ""
      }))
    };

    try {
      const res = await fetch(RUTAS_USER.UPDATE_USER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(ActualizarUsuario) 
      });

      if (!res.ok) throw new Error("Error guardando usuario");

      setMensaje("✅ Usuario agregado correctamente.");
      setMensajeTipo("success");
      setCargandoSucess(true);

      // Volver a Usuarios después de 5 segundos
      setTimeout(() => navigate("/Usuarios"), 3000);
    } catch (error) {
      setMensaje("❌ Error al guardar usuario." + JSON.stringify(ActualizarUsuario));
      setMensajeTipo("error");
    }
  };

  return (
    <LayoutGeneral titulo="Actualizar Usuario">
      <div className="home-container">
        {/* Menú lateral */}
        <aside className="sidebar">
          <ul>
            <li onClick={() => navigate("/Home")}>
              <i className="bi bi-house"></i> Inicio
            </li>
            <li onClick={() => navigate("/Usuarios")}>
              <i className="bi bi-people"></i> Usuarios
            </li>
            <li onClick={() => navigate("/Bitacoras")}>
              <i className="bi bi-journal"></i> Bitácoras
            </li>
            <li className="logout" onClick={() => { localStorage.clear(); navigate("/"); }}>
              <i className="bi bi-box-arrow-right"></i> Cerrar Sesión
            </li>
          </ul>
        </aside>

        {/* ************************** Formulario ***************************** */}
        <main className="main-content"> 
            <h1>
                <button className="btn btn-primary mt-3" onClick={regresarUsuarios}>
                    Regresar
                </button>
                <center> <span> Actualización de Usuario {idUsuario} </span> </center>
            </h1>
         {/* ************************** Parte Superior */}
          <form onSubmit={guardarUsuario} className="nuevo-usuario-form">
            <div className="d-flex justify-content-end align-items-center mb-2">
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="estatusSwitch"
                  checked={estatusUsuario === 1}
                  onChange={() => setEstatusUsuario(estatusUsuario === 1 ? 0 : 1)}
                />
                <label className="form-check-label ms-2" htmlFor="estatusSwitch">
                  {estatusUsuario === 1 ? "Activo" : "Inactivo"}
                </label>
              </div>
            </div>
            <div className="mb-3">
              <label>Nombre</label>
              <input type="text" className="form-control" value={nombre} onChange={(e) => setNombre(e.target.value)} />
            </div>

            <div className="mb-3">
              <label>Correo</label>
              <input type="email" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>

            <div className="mb-3">
              <label>Es Administrador</label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="esAdmin"
                  checked={esAdmin}
                  onChange={(e) => setEsAdmin(e.target.checked ? 1 : 0)}
                />
                <label className="form-check-label" htmlFor="esAdmin">
                  {esAdmin === 1 ? "Sí" : "No"}
                </label>
              </div>
            </div>

            {/* ************************** Parte Inferior */}
            <hr />
            <center><h5>Vincular codigos de intermediario al usuario</h5></center><br />

            <div className="d-flex mb-3 align-items-end">
              <input type="text" className="form-control me-2" placeholder="Código de intermediario" value={codEmp}
                 onChange={(e) => setCodEmp(e.target.value)} />

              <label className="rolesa"> Rol </label>
              <select className="form-control selecsito" value={rol} onChange={(e) => setRol(e.target.value)} >
                <option value="">Seleccione un perfil</option>
                {roles.map((r, idx) => (
                  <option key={idx} value={r.idRol}>
                    {r.rol}
                  </option>
                ))}
              </select>

              <button type="button" className="btn btn-success" onClick={validarCodEmp}> Validar </button>
            </div>

            {/* Tabla de codigos agregados */}
            {empleados.length >= 0 && (
              <table className="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Nombre</th>
                    <th>Oficina</th>
                    <th>Rol(PA)</th>
                    <th>Jefe Directo</th>
                    <th>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {empleados.map((emp, idx) => (
                    <tr key={idx}>
                      <td>{emp.codigo}</td>
                      <td>{emp.Nombre}</td>
                      <td>{emp.Oficina}</td>
                      <td>{emp.Rol}</td>
                      <td>
                          <select className="form-control" value={emp.jefe || ""}
                            onChange={(e) => {
                              const updated = [...empleados];
                              updated[idx].jefe = parseInt(e.target.value, 10); // guardamos el idUsuario
                              setEmpleados(updated);
                            }}>
                            <option value="">Seleccione un jefe</option>
                              {usuarios.map((u) => (
                                <option key={u.idUsuario} value={u.idUsuario}>
                                  {u.nombre} - {u.email}
                                </option>
                              ))}
                          </select>
                      </td>
                      <td>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`oficinaSwitch${idx}`}
                            checked={emp.estatusOficina === 1}
                            onChange={() => {
                              const updated = [...empleados];
                              updated[idx].estatusOficina = updated[idx].estatusOficina === 1 ? 0 : 1;
                              setEmpleados(updated);
                            }}
                          />
                          <label className="form-check-label" htmlFor={`oficinaSwitch${idx}`}>
                            {emp.estatusOficina === 1 ? "Activo" : "Inactivo"}
                          </label>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* Mensaje */}
            {mensaje && (
              <div className={`alert mt-3 ${ mensajeTipo === "success" ? "alert-success" : "alert-danger" }`}> {mensaje} </div>
            )}

            {/* Solo se muestra cuando es correcto */}
            {cargandoSucess && (
              <center>
                <img className="cargando-image mb-5" src={cargando} alt="Cargando..." />
              </center>
            )}

            <button type="submit" className="btn btn-primary mt-3">
              Actualizar Usuario
            </button>
          </form>
        </main>
      </div>
    </LayoutGeneral>
  );
};

export default ActualizarUsuario;
